import { Component } from '@angular/core';
import { WidgetBaseComponent } from '../widget-base/widget-base.component';

@Component({
  selector: 'widget-articles-group',
  templateUrl: './articles-group.component.html',
  styleUrls: ['./articles-group.component.scss'],
})
export class ArticlesGroupComponent extends WidgetBaseComponent {}
